/* NOTE: This is the starter file for CRA(Create React App), do not move it or rename it */
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './client/containers/app'
import registerServiceWorker from './buildUtils/registerServiceWorker'

ReactDOM.render(<BrowserRouter basename='/'><App /></BrowserRouter>, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js